import { DriverSeasonalBonus } from '../_models/seasonal-bonus.model';

/** Local date parts, not toISOString(): a UTC conversion would move the date across midnight. */
export function toIsoDate(date: Date): string {
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * What one worked day is worth, 0 when no season covers it.
 *
 * Mirrors DriverSalaryV2Formula::seasonalRateFor: a season naming the driver's kind beats a
 * company-wide one, so "TIR 30 zł" replaces "wszyscy 20 zł" for that day rather than stacking on top
 * of it. Dates are compared as ISO strings, which sorts correctly and cannot drift with the timezone.
 */
export function seasonalRateForDay(seasons: DriverSeasonalBonus[], day: Date): number {
	const iso = toIsoDate(day);
	let kindRate = 0;
	let generalRate = 0;

	for (const season of seasons) {
		if (iso < season.date_from || iso > season.date_to) continue;

		if (season.kind_specific) {
			kindRate = Math.max(kindRate, season.rate_per_day);
		} else {
			generalRate = Math.max(generalRate, season.rate_per_day);
		}
	}

	return kindRate !== 0 ? kindRate : generalRate;
}
